import { InjectionToken } from '@angular/core';
import { AuthUnicornConfig } from '../models/auth-unicorn-config.model';

export const AUTH_CONFIG = new InjectionToken<AuthUnicornConfig>('Auth_config');
